function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3918",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3917"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2301",
  d: "M0 0H6.123V3.072H0z",
  transform: "translate(0 14.443)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2302",
  d: "M0 0H10.222V3.072H0z",
  transform: "translate(0 9.83)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2303",
  d: "M0 0H13.434V3.071H0z",
  transform: "translate(0 4.916)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2304",
  d: "M0 0H18V3.071H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_820",
  d: "M9.852 4.973l2.984 2.9a.269.269 0 0 0 .405.024c.284-.283 2.91-3 2.91-3s.363-.361-.119-.361h-1.249V.369S14.788.2 14.565.2h-3.072c-.311 0-.258.206-.258.206v4.223H9.882c-.397 0-.03.344-.03.344z",
  transform: "translate(1.717 9.527)"
})));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2316",
  fill: "none",
  d: "M0 0H20V20H0z"
});
var SvgTopHoldersList = function SvgTopHoldersList(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_260_1",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTopHoldersList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/top-holders-list.8d6a3ae1.svg";
export { ForwardRef as ReactComponent };